import {storage, StorageKeys} from '../storage';
import {settings as settingsProd} from './config.prod';
import {settings as settingsTest} from './config.test';
import {settings as settingsStage} from './config.stage';

export enum ApiEnvironments {
  prod = 'prod',
  test = 'test',
  stage = 'stage',
}

export interface SettingParams {
  baseUrl: string;
  webProxyUrl?: string;
}

export class Settings {
  private static environment = ApiEnvironments.prod;
  private static settings: SettingParams = settingsProd;

  public static setSettings(environment: ApiEnvironments) {
    Settings.environment = environment;
    storage.setItem(StorageKeys.api, Settings.environment === ApiEnvironments.prod ? '' : Settings.environment);

    switch (environment) {
      case ApiEnvironments.stage:
        Settings.settings = settingsStage;
        break;
      case ApiEnvironments.test:
        Settings.settings = settingsTest;
        break;
      case ApiEnvironments.stage:
        Settings.settings = settingsStage;
        break;
      default:
        Settings.settings = settingsProd;
    }
  }

  public static getSettings() {
    return Settings.settings;
  }

  public static getIsTest() {
    return [ApiEnvironments.test, ApiEnvironments.stage].includes(Settings.environment);
  }
}
